import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

const RmaRequestSchema = z.object({
  rmaRequestId: z.string().nullish(),
  number: z.string().nullish(),
  supplierId: z.string().nullish(),
  authorizationProfileId: z.string().nullish(),
  status: z.string().nullish(),
  originSource: z.string().nullish(),
  claimReason: z.string().nullish(),
  createdBy: z.string().nullish(),
  createdAt: z.string().nullish(),
  modifiedBy: z.string().nullish(),
  modifiedAt: z.string().nullish(),
  completedBy: z.string().nullish(),
  completedAt: z.string().nullish(),
  note: z.string().nullish(),
  referenceKey: z.string().nullish(),
});

/**
 * GET
 */
export const GetRmaRequestRequestSchema = z.object({
  rmaRequestId: z.string(),
});
export type GetRmaRequestRequest = z.infer<typeof GetRmaRequestRequestSchema>;

export const GetRmaRequestResponseSchema = RmaRequestSchema;
export type GetRmaRequestResponse = z.infer<typeof GetRmaRequestResponseSchema>;

/**
 * POST
 */
export const PostRmaRequestRequestSchema = z.object({
  supplierId: z.string(),
  authorizationProfileId: z.string(),
});
export type PostRmaRequestRequest = z.infer<typeof PostRmaRequestRequestSchema>;

export const PostRmaRequestResponseSchema = z.object({
  rmaRequestId: z.string(),
});
export type PostRmaRequestResponse = z.infer<typeof PostRmaRequestResponseSchema>;

/**
 * PATCH
 */
export const PatchRmaRequestRequestSchema = z.object({
  rmaRequestId: z.string(),
  body: z.object({
    supplierId: z.string(),
    authorizationProfileId: z.string(),
  }),
});
export type PatchRmaRequestRequest = z.infer<typeof PatchRmaRequestRequestSchema>;

export const PatchRmaRequestResponseSchema = RmaRequestSchema;
export type PatchRmaRequestResponse = z.infer<typeof PatchRmaRequestResponseSchema>;

/**
 * DELETE items
 */
export const DeleteRmaRequestItemsRequestSchema = z.object({
  rmaRequestId: z.string(),
  body: z.object({
    itemIds: z.array(z.string()),
  }),
});
export type DeleteRmaRequestItemsRequest = z.infer<typeof DeleteRmaRequestItemsRequestSchema>;

export const DeleteRmaRequestItemsResponseSchema = BaseVoidResponseSchema;
export type DeleteRmaRequestItemsResponse = z.infer<typeof DeleteRmaRequestItemsResponseSchema>;
